import { openNotification } from "../../globals/Components/Notification/Notification";
import validateMessages from "../../globals/inputs/validateMessages";
import configureApiRestService from "../../Services/apiService";
import { loginCookie, getIdCookie, tenantCookie, modulesCookie, rolCookie, getUserCookie, setValidationMainModules } from "../../Services/auth"
import { serverMessages } from "../serverMessages";
import { setMessageResponse, toggleLoadingIndicator, toggleShowMyUser } from "../system/actions";
import { MessageResponse } from "../system/types";
import { AppThunk } from "../thunks";
import { addMainModuleId } from "./actions";
import {GetAllClientsAPI,PostClientsAPI,LoginAPI,ChangePasswordAPI,ForgotPasswordAPI,ResetPasswordAPI } from "./restCallUser";
//import { CredentialsRequest, MainModuleDataType, } from "./types";
export const ResetPassword = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await ResetPasswordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Contraseña restablecida correctamente")
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const ForgotPassword = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await ForgotPasswordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Proceso ejcutado correctamente")
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const ChangePassword = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await ChangePasswordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Contraseña cambiada correctamente")
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllClients = (value: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetAllClientsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postClients = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await PostClientsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso", "Proceso ejcutado correctamente")
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const login = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await LoginAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        const token = responseData.Response?.token;
        if (token) {
            loginCookie(token);
        }
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso", "Proceso ejcutado correctamente")
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};